import ReactPlayer from "react-player";
import styled from "styled-components";
import { ENTER_VIDEO_URL } from "legacy/constants/messages";
import { CLASS_NAMES } from "legacy/themes/classnames";
import type { Ref } from "react";
export interface VideoComponentProps {
  url?: string;
  autoplay?: boolean;
  controls?: boolean;
  onStart?: () => void;
  onPlay?: () => void;
  onPause?: () => void;
  onEnded?: () => void;
  onReady?: () => void;
  onProgress?: () => void;
  onSeek?: () => void;
  onError?: () => void;
  player?: Ref<ReactPlayer>;
  width?: string | number;
  height?: string | number;
}

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Error = styled.span``;

export default function VideoComponent(props: VideoComponentProps) {
  const {
    url,
    autoplay,
    controls,
    onStart,
    onPlay,
    onPause,
    onEnded,
    onReady,
    onProgress,
    onSeek,
    onError,
    player,
    width,
    height,
  } = props;
  return (
    <div
      className={CLASS_NAMES.DEFAULT_CONTAINER}
      style={{ overflow: "hidden" }}
    >
      {url ? (
        <ReactPlayer
          url={url}
          ref={player}
          playing={autoplay}
          controls={controls || true}
          onStart={onStart}
          onPlay={onPlay}
          onPause={onPause}
          onEnded={onEnded}
          onReady={onReady}
          onProgress={onProgress}
          onSeek={onSeek}
          onError={onError}
          pip={false}
          width={width}
          height={height}
        />
      ) : (
        <ErrorContainer>
          <Error>{ENTER_VIDEO_URL}</Error>
        </ErrorContainer>
      )}
    </div>
  );
}
